import WebsiteSensorExclusionCreate from './Create';

export default {
    create: WebsiteSensorExclusionCreate,
};
